export const styles = {
    card: {
        marginBottom: 32,
        padding: 16,
        backgroundColor: 'white !important',
    },
    inputField: {
        display: 'none',
    },
    uploadButton: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 16,
    },
    previewImageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '.5lh',
        backgroundColor: '#DDD',
        marginBottom: 16,
        maxWidth: 195,
        border: '2px dashed #EEE',
        padding: 8,
        position: 'relative',
    },
    previewImage: {
        maxWidth: '100%',
    },
    deleteButton: {
        position: 'absolute',
        top: -8,
        right: -8,
        backgroundColor: 'white',
    },
    sectionHeader: {
        marginBottom: 16,
        fontWeight: 'bold',
    },
    gridContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 16,
    },
    medioPagoContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 16,
    },
    saveButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 32,
    },
    saveButton: {
        padding: '16px 32px',
        fontSize: '1.25rem',
    },
    pdfIcon: {
        width: 50,
        height: 50,
        color: '#AAA',
    },
}